import React from 'react';
import * as PropType from '../common/propType';
import PropTypes from 'prop-types';
import './index.less';
import { initKey, params2QueryString, push, get, post } from '../../utils';
import store from '../../store';
import { toast } from '../../components/notice';
import autobind from 'autobind-decorator';

export interface TabBarItemType {
    title?: string;
    icon?: any;
    to?: any;
    selectedIcon?: any;
    type: string;
}

export interface TabBarItemState {
    isShowResultDialog?: boolean; // 是否显示结果内容
    isShowGameDetailDialog?: boolean; // 是否显示弹窗
    isShowBindContineDialog?: boolean; // 是否显示绑定并且继续内容
    phoneInputValue: string;
    qrcodeInputValue: string;
    gameDetailDialogTitle?: string;
    isDisabledGetQrcode?: boolean; // 是否置灰获取验证码按钮
    countdownNum?: number;
    currentTab?: any;
    shopNum: any
}


export interface TabBarPropType extends PropType.StylePropType {
    tabs: TabBarItemType[];
    onChange?: (item: TabBarItemType, index: any) => void;
    renderTab?: (item: TabBarItemType, index: number, opt: any) => any;
    selectedType?: string;
    prefixCls?: string;
    number?: any;
}

export function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) != -1) return c.substring(name.length, c.length);
    }
    return '';
}

var countdownTimer;

class TabBar extends React.Component<TabBarPropType, TabBarItemState> {
    static defaultProps: any = {
        prefixCls: 'tabbar'
    };

    constructor(props: TabBarPropType, context: any) {
        super(props, context);
        let url: string = this.context.router.route.match.url;
        let currentTab: number = 0;
        if (url.indexOf('/home') > -1) {
            currentTab = 0;
        } else if (url.indexOf('/classification') > -1) {
            currentTab = 1;
        } else if (url.indexOf('/shop') > -1) {
            currentTab = 2;
        } else if (url.indexOf('/my') > -1) {
            currentTab = 3;
        }
        this.state = {
            currentTab: currentTab,
            isShowResultDialog: false,
            isShowGameDetailDialog: false,
            isShowBindContineDialog: false,
            phoneInputValue: '请您输入手机号',
            qrcodeInputValue: '请您输入验证码',
            gameDetailDialogTitle: '',
            isDisabledGetQrcode: false,
            shopNum: 0,
        };
    }

    componentWillMount() {
        let gameApp = store.status.gameApp;
        if (gameApp) {// 如果是游戏
            // this.checkUserIdentity();
        }
        store.user.shopNum().then(res => {
            this.setState({
                shopNum: res
            })
        })
    }


    _originPageId(index: number): string {
        switch (index) {
            case 0:
                return 'index';
            case 1:
                return 'classification';
            case 2:
                return 'shopcart';
            case 3:
                return 'mypage';
            default:
                return '';
        }
    }

    onClickItem(idx: number) {
        let { onChange, tabs } = this.props;
        let item = tabs[idx];
        if (this.isActive(item, idx)) {
            return;
        }
        if (!!item.to) {
            let that = this;
            if (!getCookie('pub-token')) {
                if (item.to == '/shop') {
                    initKey().then(() => {
                        return store.user.fetch().then(() => {
                            store.user.shopNum();
                            store.user.getShopName();
                            return store.user.add();
                        });
                    }).then(() => {
                        // 埋点，判断去购物车来源
                        let urlStr = '?' + params2QueryString({ originPageId: this._originPageId(this.state.currentTab) }, {});
                        push(item.to + urlStr, that);
                    });
                } else if (item.to == '/my') {
                    initKey().then(() => {
                        return store.user.fetch().then(() => {
                            store.user.shopNum();
                            store.user.getShopName();
                            return store.user.add();
                        });
                    }).then(() => {
                        if (store.status.gameApp) {// 游戏中
                            if (store.status.isVipOrShopkeeper) {
                                // 埋点，判断去购物车来源
                                let urlStr = '?' + params2QueryString({ originPageId: this._originPageId(this.state.currentTab) }, {});
                                push(item.to + urlStr, that);
                            } else {
                                this.setState({
                                    gameDetailDialogTitle: '绑定游戏手机号完成VIP注册',
                                    isShowGameDetailDialog: true,
                                    isShowBindContineDialog: true
                                });
                            }
                        } else {
                            // 埋点，判断去购物车来源
                            let urlStr = '?' + params2QueryString({ originPageId: this._originPageId(this.state.currentTab) }, {});
                            push(item.to + urlStr, that);
                        }
                    });
                }
            } else {
                let urlStr = '?' + params2QueryString({ originPageId: this._originPageId(this.state.currentTab) }, {});
                if (idx === 3) {
                    if (store.status.gameApp) {
                        if (store.status.isVipOrShopkeeper) {
                            push(item.to + urlStr, that);
                        } else {
                            this.setState({
                                gameDetailDialogTitle: '绑定游戏手机号完成VIP注册',
                                isShowGameDetailDialog: true,
                                isShowBindContineDialog: true
                            });
                        }
                    } else {
                        push(item.to + urlStr, that);
                    }
                } else {
                    push(item.to + urlStr, that);
                }
            }
        }
        if (onChange) {
            onChange(item, idx);
        }
    }

    isActive(item: any, idx: number) {
        let isActive = this.state.currentTab == idx;
        if (!!item.to) {
            let url = this.context.router.route.match.url;
            isActive = url.indexOf(item.to) > -1;
        }
        return isActive;
    }

    renderTab(item: TabBarItemType, idx: number) {
        let { renderTab } = this.props;
        let { prefixCls } = this.props;
        let activeCls = prefixCls + '-active';
        let inactiveCls = prefixCls + '-inactive';
        let cls = `${prefixCls}-item`;
        let isActive = this.isActive(item, idx);
        if (renderTab) {
            let el = renderTab(item, idx, isActive);
            if (el) {
                return (
                    <div
                        className={cls}
                        onClick={() => this.onClickItem(idx)}
                        key={item.type}
                    >
                        {el}
                    </div>);
            }
        }

        if (isActive) {
            cls += ' ' + activeCls;
        } else {
            cls += ' ' + inactiveCls;
        }
        return (
            <div className={cls} key={item.type} onClick={() => this.onClickItem(idx)}>
                <img src={isActive ? item.selectedIcon : item.icon} alt="" />
                {/*{isActive && idx === 0 ? null : <span>{item.title}</span>}*/}
                {idx === 2 && (this.state.shopNum != 0 && this.state.shopNum != undefined) && <div
                    style={{ right: parseInt(this.state.shopNum) >= 10 ? '2rem' : '2.5rem' }}>{parseInt(this.state.shopNum)}</div>}
                {/* {idx === 2 && this.props.number != 0 && <div
                    style={{ right: parseInt(this.props.number) >= 10 ? '2rem' : '2.5rem' }}>{parseInt(this.props.number)}</div>} */}
            </div>
        );
    }

    // 请求接口判断用户是不是VIP或者店主
    // checkUserIdentity() {
    //     get('user/v1/info').then((res) => {
    //         if (res.errCode === 200) {
    //             if (res.data.type === 1 && res.data.level === 1) {// 身份是访客
    //                 store.status.isVipOrShopkeeper = false;
    //             } else {
    //                 store.status.isVipOrShopkeeper = true;
    //             }
    //         } else {
    //             toast(res.errDesc);
    //         }
    //     });
    // }

    // 关闭弹窗
    @autobind
    onCloseDialog() {
        this.setState({
            isShowGameDetailDialog: false,
            isShowBindContineDialog: false,
            isShowResultDialog: false
        });
    }

    // 输入手机号码
    @autobind
    onPhoneInputChange(e) {
        this.setState({
            phoneInputValue: e.target.value
        });
    }

    // 输入验证码
    @autobind
    onQrcodeInputChange(e) {
        this.setState({
            qrcodeInputValue: e.target.value
        });
    }

    // 获取验证码
    @autobind
    getQrcode(e) {
        e.preventDefault();
        let sec = 60;
        let regex = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (this.state.phoneInputValue === '请您输入手机号' || '') {
            toast('请输入手机号');
        } else if (!regex.test(this.state.phoneInputValue)) {
            toast('请输入正确的手机号');
        } else {
            get('user/common/v1/6/send/message', {
                mobile: this.state.phoneInputValue
            }).then((res) => {
                if (res.errCode === 200) {
                    toast('验证码已发送, 请注意查收');
                    this.setState({
                        isDisabledGetQrcode: true,
                        countdownNum: sec
                    }, () => {
                        countdownTimer = setInterval(() => {
                            sec--;
                            if (sec <= 0) {
                                clearInterval(countdownTimer);
                                this.setState({
                                    isDisabledGetQrcode: false
                                });
                            } else {
                                this.setState({
                                    countdownNum: sec
                                });
                            }
                        }, 1000);
                    });
                } else {
                    if (res.errCode === 1016) {
                        toast('该手机号已是国孕商城VIP请更换手机号');
                    } else if (res.errCode === 1102) {
                        toast('该手机号已是国孕商城店主请更换手机号');
                    } else {
                        toast(res.errDesc);
                    }
                }
            });
        }
    }

    // 绑定并且继续
    @autobind
    bindAndContinue() {
        let regex = /^[1][3,4,5,7,8][0-9]{9}$/;
        if (this.state.phoneInputValue === '请您输入手机号' || '') {
            toast('请输入手机号');
        } else if (!regex.test(this.state.phoneInputValue)) {
            toast('请输入正确的手机号');
        } else if (this.state.qrcodeInputValue === '请您输入验证码' || '') {
            toast('请输入短信验证码');
        } else {
            this.requestBindPhone(this.state.phoneInputValue, this.state.qrcodeInputValue);
        }
    }

    // 注册VIP
    requestBindPhone(phoneInputValue, qrcodeInputValue) {
        post('user/v1/vip/register', {
            mobile: phoneInputValue,
            code: qrcodeInputValue,
            openid: store.status.openId
        }).then((res) => {
            if (res.errCode == 200) {
                store.status.isVipOrShopkeeper = true;
                clearInterval(countdownTimer);
                toast('注册成功');
                this.setState({
                    countdownNum: 60
                });
                this.onCloseDialog();
            } else {
                // res.errCode === 1015 && toast('该手机号已是国孕商城店主请更换手机号');
                // res.errCode === 1016 && toast('该手机号已是国孕商城VIP请更换手机号'); 
                // res.errCode !== 1015 && res.errCode !== 1016 && toast(res.errDesc);
                if (res.errCode === 1015) {
                    toast('该手机号已是国孕商城店主请更换手机号');
                } else if (res.errCode === 1016) {
                    toast('该手机号已是国孕商城VIP请更换手机号');
                } else {
                    toast(res.errDesc);
                }
            }
        }).catch((err) => {
            toast(err);
        });
    }

    render() {
        const { prefixCls, tabs } = this.props;
        let cls = prefixCls;
        if (this.props.className) {
            cls += ' ' + this.props.className;
        }
        let tabItems = tabs.map((item, idx) => {
            return this.renderTab(item, idx);
        });
        let style = PropType.getStyle(this.props);
        return (
            <div className={cls} style={style}>
                {tabItems}
                {/* 游戏入口中的注册VIP的弹窗start */}
                <div className={this.state.isShowResultDialog ? 'game_detail_dialog result' : 'game_detail_dialog '}
                    style={{ display: this.state.isShowGameDetailDialog ? 'block' : 'none' }}>
                    <div className='game_detail_dialog_box'>
                        <div className='close' onClick={this.onCloseDialog}></div>
                        <div className='main'>
                            <ul className='bind_contine_ul'
                                style={{
                                    display: this.state.isShowBindContineDialog ? 'block' : 'none',
                                    marginTop: '-2rem'
                                }}>
                                <li className='li1'>
                                    {
                                        this.state.gameDetailDialogTitle
                                    }
                                </li>
                                <li style={{ marginBottom: '2rem' }}>即可享受VIP价格</li>
                                <li className='same_li'>
                                    <input
                                        type="number"
                                        placeholder='请您输入手机号'
                                        className='phoneInputClass'
                                        value={this.state.phoneInputValue}
                                        onChange={this.onPhoneInputChange}
                                    />
                                </li>
                                <li className='same_li'>
                                    <input
                                        type="number"
                                        placeholder='请您输入验证码'
                                        className='qrcodeInputClass'
                                        value={this.state.qrcodeInputValue}
                                        onChange={this.onQrcodeInputChange}
                                    />
                                    <span className='line'></span>
                                    {
                                        this.state.isDisabledGetQrcode ?
                                            <span className='disabled_qrcode'>{this.state.countdownNum}s</span> :
                                            <span className='getQrcodeClass' onClick={this.getQrcode}>获取验证码</span>
                                    }
                                </li>
                                <li className='bind_contine_class' onClick={this.bindAndContinue}></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='game_detail_pop'
                    style={{ display: this.state.isShowGameDetailDialog ? 'block' : 'none' }}></div>
                {/* 游戏入口中的注册VIP的弹窗end */}
            </div>
        );
    }

    static contextTypes = {
        router: PropTypes.object
    };
}

export default TabBar;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/tab-bar/index.tsx